// 后端微服务模块前缀
export const PORT1 = 'v1'
export const PORT2 = '/hooks'
